import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

/**
 * The channels this sheet offers, in the order the spec lays them out. Link order comes from FCM via
 * the middle-end's getChannels, so it can't be relied on for presentation — this pins it.
 */
export const SHEET_CHANNELS = ['sms', 'whatsapp', 'facebook', 'email'] as const;

export type SheetChannel = (typeof SHEET_CHANNELS)[number];

export const COPY_LINK_LABEL: TranslationKey = translationKey('corgi.contact_decision_maker.share_sheet.copy_link');
export const COPY_LINK_SUCCESS_LABEL: TranslationKey = translationKey(
	'corgi.contact_decision_maker.share_sheet.copied',
);

export const CHANNEL_LABELS: Readonly<Record<SheetChannel, TranslationKey>> = {
	sms: translationKey('corgi.contact_decision_maker.share_sheet.channels.sms'),
	whatsapp: translationKey('corgi.contact_decision_maker.share_sheet.channels.whatsapp'),
	facebook: translationKey('corgi.contact_decision_maker.share_sheet.channels.facebook'),
	email: translationKey('corgi.contact_decision_maker.share_sheet.channels.email'),
};

// `share_placement` distinguishes where in the sheet a share was fired, matching the values the PSF
// slide-up already reports so the two surfaces can be compared in analysis.
export const CHANNEL_GRID_TRACKING_DATA = { share_placement: 'channel_grid' } as const;
export const ACTION_BUTTON_TRACKING_DATA = { share_placement: 'action_button' } as const;

/**
 * The spec's 52px circle with a 28px glyph. `RoundShareIconButton` renders `SocialSharing` without a
 * `size` prop, so it is always the DS default `medium` (a 32px circle) — and 52px is not a DS step
 * anyway (`large` is 48px, `x-large` 72px). Same one-off className approach as the slide-up's
 * SHARE_ICON_SIZE_CLASSNAME; that one is 60px from an experiment, so it isn't reusable here.
 */
export const SHARE_ICON_SIZE_CLASSNAME =
	'[&>*:first-child]:size-[52px] [&>*:first-child>*:first-child]:size-[52px] [&>*:first-child>*:first-child]:!transform-none [&>*:first-child>*:first-child>*:first-child]:size-[28px] [&_svg]:size-[28px]';
